module.exports = __webpack_public_path__ + "static/media/movie03.244ecf45.jpg";